import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { BpgCommonService } from './bpg-common/services/bpg-common.service';
import { environment } from 'src/environments/environment';
import { environment_Local } from 'src/environments/environment.local';
import { environment_QA } from 'src/environments/environment.qa';
import { environment_PROD } from 'src/environments/environment.prod';
import * as i0 from "@angular/core";
import * as i1 from "./bpg-common/services/bpg-common.service";
import * as i2 from "@angular/router";
import * as i3 from "./environment/services/environment.configuration";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(bpgCommonService, router, environment) {
        this.bpgCommonService = bpgCommonService;
        this.router = router;
        this.environment = environment;
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        //  console.log("ADAL :" + this.environment.loginADAL);
        //  console.log("ADAL USER INFO "+JSON.stringify(this.adalService.userInfo));
        //Check to run application locally or in staging/production using ADAL Authentication 
        var codefromurl = sessionStorage.getItem('codeResponse');
        var token = sessionStorage.getItem('id_token');
        var refresh_token = sessionStorage.getItem('refresh_token');
        var access_token = sessionStorage.getItem('access_token');
        if (codefromurl != null && token != null && refresh_token != null && access_token != null &&
            codefromurl != undefined && token != undefined && refresh_token != undefined && access_token != undefined) {
            //if (localStorage.getItem('userEmail')) {
            //let originUrl = window.location.origin
            // if (originUrl.includes('event-view-details'))
            // this.router.navigate(['/event-view-details']);
            // else
            //  this.router.navigate(['/di-home']);
            // }
            return true;
        }
        else {
            if (codefromurl != null && sessionStorage.getItem('id_token') == null) {
                return this.bpgCommonService.userLogin();
            }
            else {
                var baseLoginUrl = void 0;
                if (this.environment.envName == 'default' || this.environment.envName == 'local' || this.environment.envName == 'staging') {
                    baseLoginUrl = environment_Local.baseLoginUrl;
                }
                else if (this.environment.envName == 'qa') {
                    baseLoginUrl = environment_QA.baseLoginUrl;
                }
                else if (this.environment.envName == 'prod') {
                    baseLoginUrl = environment_PROD.baseLoginUrl;
                }
                localStorage.setItem("redirectURl", window.location.href);
                var redirectUrl = baseLoginUrl + environment.codeChallenge;
                window.location.href = redirectUrl;
                return true;
            }
        }
    };
    AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.BpgCommonService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.EnvironmentConfiguration)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
